module.exports = __webpack_public_path__ + "static/1 (6)-ba69e8cb62dfda4284bc023e01a84330.png";